export default {
    logout: 'Logout',
    select_a_song: 'Select a song',
    timeout_seconds: 'Timeout (seconds)',
    results: 'Results',
    please_enter_a_song_id: 'Please enter a song ID',
    start: 'Start',
    connecting_to_mqtt_broker: 'Connecting to MQTT broker',
    sending: 'Sending...',
    sent: 'Sent',
    please_enter_a_timeout: 'Please enter a timeout',
    connected_to_mqtt_broker: 'Connected to MQTT broker',
    connection_to_mqtt_broker_failed: 'Connection to MQTT broker failed',
    connection_lost: 'Connection lost',
    pass_key: 'Pass Key',
    wrong_pass_key: 'Wrong pass key',
    login: 'Login',
    group_id: 'Group ID',
    points: 'Points',
    select_category: 'Select category',
    artist: 'Artist',
    language: 'Language',
    release: 'Release',
    answers: 'Answers',
    movie: 'Movie',
    select_song_id: 'Select song ID',
    song_id: 'Song ID',
    mqtt_status: 'MQTT Status',
    home: 'Home',
    categories: 'Categories',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    are_you_sure_you_want_to_delete_this_category: 'Are you sure you want to delete this category?',
    name: 'Name',
    edit_category: 'Edit Category',
    add_category: 'Add Category',
    position: 'Position',
    save: 'Save',
    cancel: 'Cancel',
    songs: 'Songs',
    add_song: 'Add Song',
    edit_song: 'Edit Song',
    movie_name: 'Movie Name',
    song_name: 'Song Name',
    artist_name: 'Artist Name',
    has_movie: 'Has Movie',
    has_release: 'Has Release',
    has_artist: 'Has Artist',
    has_language: 'Has Language',
    spotify_url: 'Spotify URL',
    time: 'Time',
    timeline: 'Timeline',
    start_song: 'Start Song',
    chorus_song: 'Chorus Song',
    jump_to_chorus: 'Jump to Chorus',
    total_time: 'Total Time',
    category: 'Category',
    song: 'Song',
    sl_no: 'Sl. No.',
    actions: 'Actions',
    chorus_time: 'Chorus Time',
    solution_display_time: 'Solution Display Time',
    song_start_time: 'Song Start Time',
    chorus_start_time: 'Chorus Start Time',
    number_of_songs: 'Number of Songs',
    spotify: 'Spotify',
    connect: 'Connect',
    all: 'All',
    existing_connection_details: 'Existing Connection Details',
    devices: 'Devices',
    profile: 'Profile',
    scope: 'Scope',
    device: 'Device',
    connection_status: 'Connection Status',
    waiting_for_song_to_play: 'Waiting for song to play',
    type: 'Type',
    loading: 'Loading...',
    aliases: 'Aliases',
    movie_aliases: 'Movie Aliases',
    release_aliases: 'Release Aliases',
    artist_aliases: 'Artist Aliases',
    language_aliases: 'Language Aliases',
    settings: 'Settings',
    elastic: 'Elastic',
    load_aliases: 'Load Aliases',
    remove_suggestions_with_similar_answers: 'Remove Suggestions with Similar Answers',
    reset_points: 'Reset all points',
    are_you_sure: 'Are you sure?',
    display: 'Display',
    remove_suggestions: 'Remove Suggestions',
    keywords: 'Keywords',
    are_you_sure_you_want_to_delete_this_song: 'Are you sure you want to delete this song?',
    is_muted: 'Is Muted',
    save_and_play: 'Save and Play',
    go_back: 'Go Back',
    stop: 'Stop',
    rank: 'Rank',
    no_points: 'No Points',
    yes: 'Yes',
    jump_to_chorus_helper_text: 'Song will jump to chorus time after the specified duration. Set it to zero or less to disable jumping to chorus',
    time_helper_text: 'The time user will have to answer after the song starts playing',
    in_seconds: 'In seconds',
    in_mm_ss_format: 'In mm:ss format',
    chorus_time_helper_text: 'If jump to chorus is set to a value greater than zero, then this will be the time duration for which the chorus will play. If jump to chorus is set to zero or less, then this will be the time duration for which the song will play.',
    song_start_time_helper_text: 'The song will start playing from this time',
    chorus_start_time_helper_text: 'The chorus will start playing from this time. This will be ignored if jump to chorus is set to zero or less',
    solution_display_time_helper_text: 'The time duration for which the solution will be displayed after the user anwering time is over',
    audio_source: 'Audio Source',
    audio_upload: 'Audio Upload',
    upload_audio: 'Upload Audio',
    remove: 'Remove',
    audio: 'Audio',
    error_deleting_uploaded_file: 'Error deleting uploaded file',
    do_you_want_to_remove_audio_file_link_from_song: 'Do you want to remove audio file link from song?',
    local: 'Local',
    removed_suggestions_history: 'Removed Suggestions History',
    if_no_keywords_are_entered_then_all_suggestions_from_history_will_be_removed: 'If no keywords are entered then all suggestions from history will be removed',
    export_song_performance: 'Export Song Performance',
    export_group_performance: 'Export Group Performance',
    enter_pass_key: 'Please enter pass key',
    remove_all_suggestions_from_history: 'Remove all suggestions from history',
    local_audio_player_info: 'The song will change to the next song after the player has finished playing the current song. If paused in the middle, then manually change to the next song.',
    are_you_sure_you_want_to_remove_audio_file: 'Are you sure you want to remove audio file',
    upload_cover_image: 'Upload Cover Image',
    are_you_sure_you_want_to_remove_cover_image: 'Are you sure you want to remove cover image',
    do_you_want_to_remove_cover_image_link_from_song: 'Do you want to remove cover image link from song?',
}